module.exports = global["jQuery"] = require("-!./jquery-2.2.3.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?jQuery!./public/javascripts/jquery-2.2.3.js-exposed
// module id = 144
// module chunks = 0